import { useQuery } from '@tanstack/react-query';

import type { MultiSelectOption } from '@Components/ContentEditor/EditorFields/MultiSelectField';
import service from '@Service';
import { unwrapList } from '@Utils/unwrap';

/* eslint-disable @typescript-eslint/no-explicit-any */
const toOptions = (rows: any[]): MultiSelectOption[] =>
  rows
    .filter((row) => typeof row?.name === 'string' && row.name)
    .map((row) => ({ value: row.name, label: row.name }));
/* eslint-enable @typescript-eslint/no-explicit-any */

/**
 * Option lists for the content editor's "Show For" gating controls. Rules
 * store NAMES (tag/permission/role names) — the same identifiers the API's
 * read-path gate resolves against a member — so options map name → name.
 */
export function useShowForOptions() {
  const tags = useQuery({
    queryKey: ['show-for-options', 'tags'],
    queryFn: () => service.readAllTags(),
    staleTime: 60_000,
  });
  const permissions = useQuery({
    queryKey: ['show-for-options', 'permissions'],
    queryFn: () => service.getPermissions({}),
    staleTime: 60_000,
  });
  const roles = useQuery({
    queryKey: ['show-for-options', 'fish-roles'],
    queryFn: () => service.getFishRoles(),
    staleTime: 60_000,
  });

  return {
    tagOptions: toOptions(unwrapList(tags.data)),
    permissionOptions: toOptions(
      // PaginatedResponse types `data` loosely; normalize like the rest.
      unwrapList(permissions.data as unknown as { data?: unknown[] }),
    ),
    roleOptions: toOptions(unwrapList(roles.data)),
  };
}
